import { Preferences } from './../config/preferences';

export const persistPreferences = store => {
  store.subscribe(({ type, payload }, state) => {
    if (type.indexOf(Preferences.LocalStorageKey) === 0) {
      // persist preferences state when changes are detected
      localStorage.setItem(Preferences.LocalStorageKey, JSON.stringify(state.preferences));
    }
  });
};
